import angular from 'angular';
import 'chart.js';
import 'angular-chart.js';

import line from './line';
import chart from './chart';
import grouped from './grouped';

export default angular.module('dbm.dashboard.components.graphs', [
    'chart.js',
    line,
    chart,
    grouped
]).name;


// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/graphs/index.js